import { LoyaltyClusterTypeService } from './../../../../services/loyalty/loyalty-cluster-type.service';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { ClusterType } from 'app/models/loyalty-cluster-type.model';

@Component({
  selector: 'app-form-cluster-type-loyalty',
  templateUrl: './form-cluster-type-loyalty.component.html',
  styleUrls: ['./form-cluster-type-loyalty.component.css']
})
export class FormClusterTypeLoyaltyComponent implements OnInit {

  fields: any;
  translations: any;

  form: FormGroup;
  @Input() clusterTypeId: string;
  @Input() editMode: boolean;
  clusterTypeForm: Array<FormGroup>;

  maxLength = {
    code: 0,
    description: 0
  };

  invalidSubmit: boolean;
  texts: any;

  constructor(
    private translate: TranslateService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private clusterTypeService: LoyaltyClusterTypeService,
  ) { }

  ngOnInit() {

    /*
    per il controllo della lunghezza dei testi che inserisce l'utente
    (lunghezza massima dei testi dei campi testuali)
    */
    this.maxLength.code = 32; //varchar(32)
    this.maxLength.description = 255;  //varchar(255)

    this.clusterTypeService.getFields().subscribe(res => {
      this.fields = res;
    });

    this.translate.get([
      "common.save",
      "common.back",
      'cluster_type.cluster_type_title',
      'cluster_type.add_title',
      'cluster_type.edit_title'
    ]).subscribe((translations) => {

      this.translations = translations;

      this.texts = {
        save: this.translations['common.save'],
        back: this.translations['common.back'],
        cluster_type_title: this.translations['cluster_type.cluster_type_title'],
        add_title: this.translations['cluster_type.add_title'],
        edit_title: this.translations['cluster_type.edit_title'],
      };

      this.clusterTypeId = this.activatedRoute.snapshot.params['clusterTypeId'];
      this.editMode = (typeof this.clusterTypeId !== 'undefined');

      let clusterType: Observable<any>;

      if (this.editMode) {
        clusterType = this.clusterTypeService.get(this.clusterTypeId);

        Observable.zip(clusterType).subscribe(([resClusterType]) => {
          this.form = this.fb.group({
            code: [(resClusterType && resClusterType.data && resClusterType.data.code) ?  resClusterType.data.code : '' , Validators.compose([Validators.required,Validators.maxLength(this.maxLength["code"])])],
            description: [(resClusterType && resClusterType.data && resClusterType.data.description) ?  resClusterType.data.description : '' , Validators.compose([Validators.maxLength(this.maxLength["description"])])]
          });
        });
      }
      else{
        this.form = this.fb.group({
          code: ['' , Validators.compose([Validators.required,Validators.maxLength(this.maxLength.code)])],
          description: ['' , Validators.compose([Validators.maxLength(this.maxLength.description)])]
        });
      }


    });

  }

  save() {
    if (!this.form.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;
    let clusterType = new ClusterType();
    clusterType.code = this.form.get('code').value;
    clusterType.description = this.form.get('description').value;

    if (!this.editMode) {
      this.clusterTypeService.create(clusterType).subscribe(res => {
        this.router.navigate(['/loyalty/cluster-type']);
      });
    } else {
      clusterType.id = this.clusterTypeId;
      this.clusterTypeService.update(clusterType).subscribe(res => {
        this.router.navigate(['/loyalty/cluster-type']);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-cluster-type/form-cluster-type-loyalty/form-cluster-type-loyalty.component.ts